export default __webpack_public_path__ + "static/media/orange_orange_apple.0af69b0c.png";